import { CategoryInterface } from 'types/CategoryInterface'
import { QuestionInterface } from 'types/QuestionInterface'

export const categoryData: CategoryInterface[] = [
  {
    cat: 'general',
    name: 'Basiswissen',
    textCl: 'dark',
    textClMobile: 'bright',
    sort: 0,
    cl: 'clear',
    deskPos: { top: '12%' },
    mobPos: { width: '100%', marginLeft: '0%' }
  },
  {
    cat: 'bedroom',
    name: 'Schlafzimmer',
    textCl: 'bright',
    textClMobile: 'bright',
    sort: 7,
    cl: 'clear',
    deskPos: { top: '5vw' },
    mobPos: { width: '120%', marginLeft: '-15%' }
  },
  {
    cat: 'body',
    name: 'Körper & Psyche',
    textCl: 'dark',
    textClMobile: 'dark',
    sort: 4,
    cl: 'sky',
    deskPos: { top: '20%', maxWidth: '50%' },
    mobPos: { width: '130%', marginLeft: '-10%' }
  },
  {
    cat: 'myths',
    name: 'Richtig oder Falsch?',
    textCl: 'dark',
    textClMobile: 'dark',
    sort: 6,
    cl: 'sky',
    deskPos: { top: '30%' },
    mobPos: { width: '130%', marginLeft: '-15%' }
  },
  {
    cat: 'extreme',
    name: 'Extreme',
    textCl: 'bright',
    textClMobile: 'bright',
    sort: 5,
    cl: 'clear',
    deskPos: { top: '0%' },
    mobPos: { width: '120%', marginLeft: '-10%' }
  },
  {
    cat: 'snore',
    name: 'Schnarchen',
    textCl: 'bright',
    textClMobile: 'dark',
    sort: 8,
    cl: 'sky',
    deskPos: { top: '75%' },
    mobPos: { width: '130%', marginLeft: '-10%' }
  },
  {
    cat: 'dreams',
    name: 'Träumen',
    textCl: 'dark',
    textClMobile: 'dark',
    sort: 2,
    cl: 'sky',
    deskPos: { top: '50%' },
    mobPos: { width: '130%', marginLeft: '-25%' }
  },
  {
    cat: 'disorder',
    name: 'Schlafstörungen',
    textCl: 'dark',
    textClMobile: 'bright',
    sort: 3,
    cl: 'clear',
    deskPos: { top: '70%' },
    mobPos: { width: '125%', marginLeft: '-13%' }
  }

  // {
  //   cat: 'a',
  //   name: 'FALLEN WEG',
  //   textCl: 'dark',
  //   textClMobile: 'bright',
  //   sort: 9,
  //   cl: 'sky',
  //   vertPos: '15%',
  //   mobPos: { width: '160%', marginLeft: '-15%' }
  // },
].sort((a, b) => {
  return a.sort - b.sort
})

export const QuestionDefaults: QuestionInterface = {
  category: '',
  desktopType: 'narrow',
  fileId: '',
  icon: '',
  iconDesktopPos: 'left',
  iconready: '',
  question: '',
  questionOrder: ''
}
